import React, { useEffect, useRef, useState } from "react";
import DropdownFilter from "./DropdownFilter";
import SearchFilter from "./SearchFilter";
import Button from "../ui/Button";
import MultiSelectFilter from "./MultiSelectFilter";
import { useTable } from "./Table";
import ResetFilters from "./ResetFilters";

const Filters = ({tableName,setResetKey}) => {
  const {
    data,
    columns,
    onSubmit,
    status,
    onSelectAllRows,
    selectedRows,
    isFocused,
  } = useTable();

  const rowRef = useRef();
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const visibleColumns = isMobile ? showMore ? columns.filter((col) => !col.isDisabled && col.isActive).length : 4 : columns.filter((col) => !col.isDisabled && col.isActive).length;
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Check immediately on component mount
    checkScreenSize();
    
    // Also listen for resize events
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
    }, []);
  const handleKeyPress = (e) => {
    if (e.key === "Enter") onSubmit();
  };

  useEffect(() => {
    if (onSubmit && isFocused) {
      if (status.fetchData !== "loading")
        window.addEventListener("keypress", handleKeyPress);
      return () => window.removeEventListener("keypress", handleKeyPress);
    }
  }, [status.fetchData, isFocused]);

  return (
    <tr ref={rowRef} className="border-b contents">
      {onSelectAllRows && selectedRows && (
        <td>
          <div
            id="select-all-rows"
            className="flex justify-center text-sm lg:text-base"
          >
            <input
              type="checkbox"
              className="checkbox checkbox-black"
              checked={
                data.length !== 0 &&
                data.every((row) => tableName === 'LookupTable' ? selectedRows.includes(row.voter_id)  : selectedRows.includes(row.id))
              }
              onChange={onSelectAllRows}
            />
          </div>
        </td>
      )}

      {columns
        .filter((col) => col.isDisabled !== true)
        .filter((col) => col.isActive).splice(0,visibleColumns)
        .map((col) => {
          switch (col.filter.type) {
            case "search":
              return (
                <SearchFilter
                  key={col.key}
                  colKey={col.key}
                  name={col.text}
                  {...col.filter}
                  shouldDebounce={!onSubmit}
                />
              );
            case "dropdown":
              return (
                <DropdownFilter
                  key={col.key}
                  colKey={col.key}
                  name={col.text}
                  {...col.filter}
                  shouldDebounce={!onSubmit}
                  tableName={tableName}
                  col={col}
                />
              );
            case "multiselect":
              return (
                <MultiSelectFilter
                  key={col.key}
                  colKey={col.key}
                  name={col.text}
                  {...col.filter}
                  shouldDebounce={!onSubmit}
                />
              );
          }
        })}
        {
          isMobile ? 
            <button 
              onClick={() => setShowMore(!showMore)} 
              className="text-[18px] leading-[22px] tracking-normal font-mont text-customRed underline underline-offset-2"
            >
              {showMore ? (
                <span className="flex items-center">
                  <span>Less Fields</span>
                </span>
              ) : (
                <span className="flex items-center">
                  <span>More Fields</span>
                </span>
              )}
            </button>
          : null
        }
      {
        tableName === 'myList' ? <td></td> : null
      }
      {onSubmit && (
        <>
          {tableName === 'LookupTable' ? 
          <td className="h-[52px] sticky right-0 !pl-0">
            <div className="min-w-[100px] mr-[1px] flex bg-white md-lg:pl-2 py-[5px] after:content-[''] after:absolute after:top-[2px] after:right-0 after:w-[9px] after:h-[50px] after:bg-white">
              <Button
                id="search-btn"
                state={status.fetchData}
                disabled={status.fetchData === "loading"}
                onClick={onSubmit}
                className="text-[13px] lg:text-[15px] !px-1 w-full h-auto"
              >
                SEARCH
              </Button>
              {tableName === 'LookupTable' ? <ResetFilters setResetKey={setResetKey} tableName={tableName} /> : <></>}
            </div>
          </td>
          :
          <td className="h-[52px] sticky right-0">
            <div className="min-w-[100px] flex bg-white after:content-[''] after:absolute after:top-[2px] after:right-0 after:w-[9px] after:h-[50px] after:bg-white">
              <Button
                id="search-btn"
                state={status.fetchData}
                disabled={status.fetchData === "loading"}
                onClick={onSubmit}
                className="text-[13px] lg:text-[15px] !px-1 w-full"
              >
                SEARCH
              </Button>
            </div>
          </td>
        }
        </>
      )}
    </tr>
  );
};

export default Filters;
